/* eslint-disable */
import { AgreementApiModel } from '../models/DealModel';
import { isPayByUser } from '../constants';

export function getGroupName(deals: AgreementApiModel[], groupId: string) {
  if (groupId === '*') return 'All Products';
  for (const deal of deals) {
    const groupName = deal.groups?.find((g) => g.id === groupId)?.name;
    if (groupName) return groupName;
  }
  return null;
}


export function dealHasExpired(deal: AgreementApiModel): boolean{
  if(deal?.expiration){
    return (new Date(deal.expiration)).getTime() < (new Date()).getTime();
  }
  return false;
}

export function dealHasNoAvailableProducts(deal: AgreementApiModel): boolean {
  const isPayByUserDeal =
    deal?.isPayByUser || isPayByUser(deal?.paymentArrangement || '');
  if (isPayByUserDeal) return false;
  const nonRetiredProducts = deal?.products?.filter((p) => !p.retired) ?? [];
  return nonRetiredProducts.every((p) => p.quantityRemaining <= 0);
}
